import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../styles/chests.css";
import { defaultChestSvg } from "img/chests/defaultChest";
import { emptyChestSvg } from "img/chests/emptyChest";
import { gemsChestSvg } from "img/chests/gemsChest";
import { starsChestSvg } from "img/chests/starsChest";

import useTelegram from "hooks/telegram-hook";
import UserApi from "../services/api-service";

interface RewardResponse {
  reward_type: string;
  amount: number;
  keys_left: number;
}

type ChestSvgProps = { pathname: string };
type SvgComponentType = React.FC<ChestSvgProps>;

const ChestPage: React.FC = () => {
  const tg = useTelegram();
  const userId = tg?.user?.id || "1938421476";

  const location = useLocation();

  const [keys, setKeys] = useState<number>(0);
  const [prizeText, setPrizeText] = useState<string | null>(null);
  const [isOpening, setIsOpening] = useState<boolean>(false);
  const [chestSvgs, setChestSvgs] = useState<SvgComponentType[]>(
    Array(3).fill(defaultChestSvg)
  );

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const { Chests } = await UserApi.getUser(userId);
        setKeys(Number(Chests) || 0);
        setChestSvgs(Array(3).fill(defaultChestSvg));
      } catch (err) {
        console.error("Не удалось загрузить данные пользователя:", err);
      }
    };

    fetchUserData();
  }, [userId]);

  const handleChestClick = async (clickedIndex: number) => {
    if (isOpening || keys <= 0) return;
    setIsOpening(true);

    try {
      const res = await fetch(
        `https://pablohouse.su:8080/case/open/${userId}`,
        {
          method: "POST",
        }
      );
      const data: RewardResponse = await res.json();
      setKeys(data.keys_left);

      const rewardConfig: Record<
        string,
        { text: string; Svg: SvgComponentType }
      > = {
        nothing: { text: "Пусто :(", Svg: emptyChestSvg },
        balance: { text: `Старки ${data.amount}`, Svg: starsChestSvg },
        gems: { text: `Гемы ${data.amount}`, Svg: gemsChestSvg },
      };

      const mainReward = rewardConfig[data.reward_type] || {
        text: "Ты получил что-то!",
        Svg: defaultChestSvg,
      };

      const newChestSvgs: SvgComponentType[] = Array(3).fill(defaultChestSvg);

      newChestSvgs[clickedIndex] = mainReward.Svg;

      setPrizeText(mainReward.text);
      setChestSvgs(newChestSvgs);
    } catch (err) {
      console.error("Ошибка открытия сундука:", err);
      setPrizeText("Ошибка подключения");
    }

    setIsOpening(false);
  };

  return (
    <div className="chests-page">
      <div className="chests-header">
        <span className="keys-count">Ключи</span>
        <span className="keys-value">{keys}</span>
      </div>

      <div className="chests-container">
        {chestSvgs.map((Svg, idx) => (
          <div
            key={`${Svg.name}-${idx}`}
            className={`chest-svg ${isOpening || keys <= 0 ? "disabled" : ""}`}
            onClick={
              isOpening || keys <= 0 ? undefined : () => handleChestClick(idx)
            }
            style={{ cursor: isOpening || keys <= 0 ? "default" : "pointer" }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !isOpening && keys > 0)
                handleChestClick(idx);
            }}
            aria-disabled={isOpening || keys <= 0}
          >
            <Svg pathname={location.pathname} />
          </div>
        ))}
      </div>
      {keys > 0 ? (
        <div className="chests-title">Выбери сундук</div>
      ) : (
        <div className="not-enough-keys">Недостаточно ключей</div>
      )}

      {prizeText && (
        <div className="prize-text">
          <div>Твоя награда</div>
          <div>{prizeText}</div>
        </div>
      )}
    </div>
  );
};

export default ChestPage;
